import {
  PUBLIC_SEARCH_FORBIDDEN_MESSAGE,
  PUBLIC_SEARCH_INVALID_INPUT_MESSAGE,
  PUBLIC_SEARCH_RATE_LIMITED_MESSAGE,
  PUBLIC_SEARCH_SERVER_ERROR_MESSAGE,
} from "@/lib/errors/error-messages";
import { ClientHttpError, clientPost } from "@/lib/http/client-http";

import {
  publicSearchErrorResponseSchema,
  publicSearchPageSchema,
} from "./public-search-schemas";
import type {
  PublicSearchErrorCode,
  PublicSearchPage,
  PublicSearchRequest,
} from "./public-search-types";

const PUBLIC_SEARCH_BFF_PATH = "/api/public/gift-lists/search";

const PUBLIC_SEARCH_ERROR_STATUS: Record<PublicSearchErrorCode, number> = {
  INVALID_INPUT: 400,
  FORBIDDEN: 403,
  RATE_LIMITED: 429,
  SERVER_ERROR: 502,
};

const PUBLIC_SEARCH_ERROR_MESSAGE: Record<PublicSearchErrorCode, string> = {
  INVALID_INPUT: PUBLIC_SEARCH_INVALID_INPUT_MESSAGE,
  FORBIDDEN: PUBLIC_SEARCH_FORBIDDEN_MESSAGE,
  RATE_LIMITED: PUBLIC_SEARCH_RATE_LIMITED_MESSAGE,
  SERVER_ERROR: PUBLIC_SEARCH_SERVER_ERROR_MESSAGE,
};

export class PublicSearchClientError extends ClientHttpError {
  readonly code: PublicSearchErrorCode;

  constructor(code: PublicSearchErrorCode) {
    super(PUBLIC_SEARCH_ERROR_STATUS[code], PUBLIC_SEARCH_ERROR_MESSAGE[code]);
    this.name = "PublicSearchClientError";
    this.code = code;
  }
}

export async function searchPublicGiftLists(
  request: PublicSearchRequest,
  signal?: AbortSignal,
): Promise<PublicSearchPage> {
  const response = await clientPost<unknown>(PUBLIC_SEARCH_BFF_PATH, request, { signal });
  const success = publicSearchPageSchema.safeParse(response);
  if (success.success) return success.data;

  const failure = publicSearchErrorResponseSchema.safeParse(response);
  if (failure.success) throw new PublicSearchClientError(failure.data.code);

  throw new ClientHttpError(502, PUBLIC_SEARCH_SERVER_ERROR_MESSAGE);
}
